(function(){
  'use strict';
  var DATA = window.PRAYASA_VIDEOS || [];

  function esc(s){ return String(s == null ? '' : s).replace(/"/g,'&quot;'); }

  function buildCard(v){
    var card = document.createElement('div');
    card.className = 'pvc__card';
    var mediaWrap = document.createElement('div');
    mediaWrap.className = 'pvc__media';

    var video = document.createElement('video');
    video.className = 'pvc__vid';
    video.muted = true;
    video.loop = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.preload = 'none';
    video.poster = v.poster || '';
    video.setAttribute('data-src', v.src);

    var soundBtn = document.createElement('button');
    soundBtn.type = 'button';
    soundBtn.className = 'pvc__sound';
    soundBtn.setAttribute('aria-label', 'Toggle sound');
    soundBtn.innerHTML = '<svg class="pvc__ic-off" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M11 5 6 9H3v6h3l5 4V5z"/><line x1="16" y1="9" x2="21" y2="15"/><line x1="21" y1="9" x2="16" y2="15"/></svg><svg class="pvc__ic-on" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" hidden><path d="M11 5 6 9H3v6h3l5 4V5z"/><path d="M15.5 8.5a5 5 0 0 1 0 7"/><path d="M18 6a9 9 0 0 1 0 12"/></svg>';
    soundBtn.addEventListener('click', function(){
      video.muted = !video.muted;
      soundBtn.querySelector('.pvc__ic-off').hidden = !video.muted;
      soundBtn.querySelector('.pvc__ic-on').hidden = video.muted;
    });

    mediaWrap.appendChild(video);
    mediaWrap.appendChild(soundBtn);

    if(v.handle && v.title){
      var shop = document.createElement('a');
      shop.className = 'pvc__shop';
      shop.href = '/collections/' + v.handle;
      shop.innerHTML = 'Shop ' + esc(v.title) + ' <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
      mediaWrap.appendChild(shop);
    } else {
      var tag = document.createElement('span');
      tag.className = 'pvc__tag';
      tag.textContent = 'Prayasa';
      mediaWrap.appendChild(tag);
    }

    card.appendChild(mediaWrap);
    return card;
  }

  function attachObserver(track){
    var videos = Array.prototype.slice.call(track.querySelectorAll('video'));
    if(!videos.length) return;
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        var video = entry.target;
        if(entry.isIntersecting && entry.intersectionRatio >= 0.6){
          if(!video.src && video.getAttribute('data-src')){ video.src = video.getAttribute('data-src'); }
          var p = video.play();
          if(p && p.catch) p.catch(function(){});
        } else {
          video.pause();
        }
      });
    }, {root: track, threshold: [0, 0.6]});
    videos.forEach(function(video){ io.observe(video); });
  }

  function renderInto(track, list){
    if(!list.length){
      var section = track.closest('.pvc');
      if(section) section.remove();
      return;
    }
    var frag = document.createDocumentFragment();
    list.forEach(function(v){ frag.appendChild(buildCard(v)); });
    track.appendChild(frag);
    attachObserver(track);
  }

  document.querySelectorAll('.pvc[data-pvc-mode="home"] .pvc__track').forEach(function(track){
    renderInto(track, DATA);
  });

  document.querySelectorAll('.pvc[data-pvc-mode="product"] .pvc__track').forEach(function(track){
    var handles = window.PRAYASA_PRODUCT_COLLECTION_HANDLES || [];
    var list = DATA.filter(function(v){ return v.handle && handles.indexOf(v.handle) !== -1; });
    renderInto(track, list);
  });
})();
